import { colors } from '@insurancemenu/imenu-components-lib';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import { createUseStyles } from 'react-jss';

const styles = {
  modal: {
    position: 'absolute',
    zIndex: 4,
    top: '6rem',
    width: '40rem',
    maxHeight: '55rem',
    backgroundColor: colors.neutral.white,
    borderRadius: '0.6rem',
    boxShadow: boxShadows.dark[4],
  },
  leftAlignment: {
    left: 0,
  },
  rightAlignment: {
    right: 0,
  },
  centerAlignment: {
    left: '50%',
    transform: 'translateX(-50%)',
  },
  show: {
    display: 'block',
  },
  hide: {
    display: 'none',
  },
  warningContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  warningText: {
    fontSize: '1.8rem',
    lineHeight: '2.4rem',
    maxWidth: '23.8rem',
    textAlign: 'center',
    textTransform: 'none',
    letterSpacing: '0.02em',
    margin: '2rem 0 3rem',
  },
  demoButtons: { display: 'flex', alignItems: 'center' },
  arrow: { margin: '0 1.6rem' },
  cancelWarningModalBtn: {
    margin: '2rem 0 3rem',
    padding: '0rem 5rem',
  },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  actionButton: {
    marginLeft: '2rem',
    padding: '0rem 2rem',
  },
  icon: {
    marginTop: '3rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
